var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriadoras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "M24 42q-3.15 0-5.325-2.175Q16.5 37.65 16.5 34.5H9q-1.2 0-2.1-.9-.9-.9-.9-2.1 0-7.6 4.675-12.9 4.675-5.3 11.825-5.85V6h3v6.75q7.15.55 11.825 5.85Q42 23.9 42 31.5q0 1.2-.9 2.1-.9.9-2.1.9h-7.5q0 3.15-2.175 5.325Q27.15 42 24 42ZM9 31.5h30q0-6.6-4.375-11.175Q30.25 15.75 24 15.75t-10.625 4.575Q9 24.9 9 31.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriadoras);
export default __webpack_public_path__ + "static/media/criadoras.e4425c825cecbf7eb54f2f314d59e4e8.svg";
export { ForwardRef as ReactComponent };